import { render, staticRenderFns } from "./EmailMetricsCard.vue?vue&type=template&id=15ef4f54&scoped=true"
import script from "./EmailMetricsCard.vue?vue&type=script&lang=js"
export * from "./EmailMetricsCard.vue?vue&type=script&lang=js"
import style0 from "./EmailMetricsCard.vue?vue&type=style&index=0&id=15ef4f54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ef4f54",
  null
  
)

export default component.exports